import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DrawerService {
  private readonly drawerToggleSubject = new Subject<void>();
  private readonly drawerCloseSubject = new Subject<void>();

  drawerToggle$ = this.drawerToggleSubject.asObservable();
  drawerClose$ = this.drawerCloseSubject.asObservable();

  toggleDrawer() {
    this.drawerToggleSubject.next();
  }

  closeDrawer() {
    this.drawerCloseSubject.next();
  }
}
